import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import RoyaltyLicensorForm from './forms/RoyaltyLicensorForm';
import RoyaltyLicensorList from './lists/RoyaltyLicensorList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class RoyaltyLicensorEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    deleteForm = async () => {
        await this.props.deleteForm();
        this.editor && this.editor.hide();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
            <List
                {...this.props}
                collapsed={this.props.collapsed || false}
                theme="default"
                header="Jogdíj tulajdonosok"
                footer={[
                    <Button
                        key="0"
                        disabled={this.props.isLoading}
                        color="default"
                        onClick={this.pristineForm}
                    >
                        Új
                    </Button>
                ]}
            >
                <RoyaltyLicensorList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
            </List>
            <Editor
                {...this.props}
                ref={(editor) => this.editor = editor}
                theme="default"
                header="Jogdíj tulajdonos"
                footer={[
                    <Button
                        key="0"
                        disabled={!this.props.dirty || this.props.isLoading}
                        color="primary"
                        className="pull-right"
                        onClick={this.saveForm}
                    >
                        Mentés
                    </Button>,
                    <Button
                        key="1"
                        disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                        color="danger"
                        className="pull-left"
                        onClick={this.deleteForm}
                    >
                        Törlés
                    </Button>
                ]}
            >
                <RoyaltyLicensorForm {...this.props} />
            </Editor>
        </Fragment>;
    }
}

export default createEditor({
    componentName: "RoyaltyLicensor",
    WrappedComponent: RoyaltyLicensorEditor,
    props: {
        view: "admin"
    }
});
